import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { element: String, action: String, name: String }
  }

  connect() {
    let targetElement = document.querySelector(this.elementValue)

    if (targetElement) {
      switch (this.actionValue) {
        case "add":
          targetElement.classList.add(this.nameValue)
          break
        case "remove":
          targetElement.classList.remove(this.nameValue)
          break
      }
    }

    this.element.remove()
  }
}
